/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoSolicitacoesAtendimentoAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_LOCAL_ATENDIMENTO = 'autocomplete-local-atendimento',
  AVATAR_BENEFICIARIO = 'avatar-beneficiario',
  AVATAR_BENEFICIARIO_MOBILE = 'avatar-beneficiario-mobile',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  DECK_MOBILE = 'deck-mobile',
  FETCH_BENEFICIARIO = 'fetch-beneficiario',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_LOCAL_ATENDIMENTO = 'fetch-local-atendimento',
  FETCH_TIPO_GUIA = 'fetch-tipo-guia',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_6 = 'field-6',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_BENEFICIARIO_MOBILE = 'field-beneficiario-mobile',
  FIELD_DATA_SOLIC = 'field-data-solic',
  FIELD_DATA_SOLIC_MOBILE = 'field-data-solic-mobile',
  FIELD_REQUISICAO = 'field-requisicao',
  FIELD_REQUISICAO_MOBILE = 'field-requisicao-mobile',
  FIELD_RESPONSAVEL = 'field-responsavel',
  FIELD_RESPONSAVEL_MOBILE = 'field-responsavel-mobile',
  FIELD_TIPO_GUIA_MOBILE = 'field-tipo-guia-mobile',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  FILTRO_LOCAL_ATENDIMENTO = 'filtro-local-atendimento',
  FILTRO_TIPO_GUIA = 'filtro-tipo-guia',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_CUSTOM_CARD_MOBILE = 'hpms-custom-card-mobile',
  HPMS_DYNAMIC_CONTENT_SITUACAO = 'hpms-dynamic-content-situacao',
  HPMS_DYNAMIC_CONTENT_SITUACAO_MOBILE = 'hpms-dynamic-content-situacao-mobile',
  INPUT_CARTEIRA = 'input-carteira',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_BENEFICIARIO = 'mapper-beneficiario',
  MAPPER_BENEFICIARIO_MOBILE = 'mapper-beneficiario-mobile',
  MAPPER_LOCAL_ATENDIMENTO = 'mapper-local-atendimento',
  MEDIA_QUERY = 'media-query',
  MEDIA_QUERY_MOBILE = 'media-query-mobile',
  PANEL_SOLIC_PENDENTES = 'panel-solic-pendentes',
  TEXT_1 = 'text-1',
  TEXT_DATA_SOLIC = 'text-data-solic',
  TEXT_DATA_SOLIC_MOBILE = 'text-data-solic-mobile',
  TEXT_LOCAL_ATENDIMENTO = 'text-local-atendimento',
  TEXT_REQUISICAO = 'text-requisicao',
  TEXT_REQUISICAO_MOBILE = 'text-requisicao-mobile',
  TEXT_RESPONSAVEL = 'text-responsavel',
  TEXT_RESPONSAVEL_MOBILE = 'text-responsavel-mobile',
  TEXT_TIPO_GUIA_MOBILE = 'text-tipo-guia-mobile',
}
export { HistoricoSolicitacoesAtendimentoAliases };
